export default __webpack_public_path__ + "fonts/2903a2e5f3495804d1181cd9a9932b00.ttf";